module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido4.01f1c306.svg";